<script lang="ts">
  import {
    Button,
    Card,
    CardBody,
    CardSubtitle,
    CardTitle,
  } from "sveltestrap";
  import Image from "./Image.svelte";
  import { nftDetailLink } from "../utils/utils"
  import { currentChainId } from "../stores/store"
  import { link } from "svelte-routing"

  export let nft
</script>

<Card class="mb-3 nftCard" xs="12" sm="3">
  <a href="/upload/{nft.address}/{nft.id}" use:link>
    <Image class="nftCard-thumbnail" src={nft.image} />
  </a>
  <CardBody class="nftCard-body uploadCard-body">
    <CardSubtitle class="nftCard-collection">{nft.collection}</CardSubtitle>
    <CardTitle class="nftCard-title">{nft.title}</CardTitle>
    <a href={nftDetailLink(nft.address, nft.id, $currentChainId)} target="_blank">
      <Button class="uploadCard-detail">
        Detail
        <img class="icon-small" src="/icons/outlink.svg" alt="placeholder"/>
      </Button>
    </a>
  </CardBody>
</Card>
